module.exports = __webpack_public_path__ + "1dbc0ec828b1eb9ab30f2942f2fe1aab.png";


//////////////////
// WEBPACK FOOTER
// ./shared/favicons/apple-touch-icon.png
// module id = 1151
// module chunks = 2